/**************************************************************
 * Responsibility - Point of entrance for the proofing page 🐺
 * ***********************************************************
 * @format
 * */

import {DateFromNow, getLocalTime, IfBeforeCutoff} from 'frontier/utilities/format/date';
import {ProofingContextProvider, useProofingContext} from './proofing_context_provider';
import {ReviewProgress} from './order_meta/review_progress';
import {withRouter, Loading, If} from 'frontier-utilities';
import {
    ORDER_EXPEDITED_PROCESSING,
    ORDER_STATUS_COMPLETE,
    PROOF_APPROVAL_CUTOFF
} from 'frontier-constants';
import {OrderSpecs} from './order_meta/order_specs';
import {Breadcrumbs} from '@sttark/design-system';
import {ProofsList} from './proofs_list';
import {handleChange} from 'frontier-form';
import React from 'react';

// styles
import './container.sass';

const Container = withRouter(
    handleChange(props => {
        const {loading, order} = props.data;

        if (loading) {
            return <Loading message="Loading Proof" />;
        }

        const breadcrumbsLinks = [
            {label: 'Active Orders', link: '/account/orders/index'},
            {
                label: `Order #${order.id}`,
                link: `/account/orders/view/${order.id}`
            }
        ];

        if (order.is_cancelled || order.status === ORDER_STATUS_COMPLETE) {
            return (
                <div className="alert alert-info">
                    <div>This Order is not available for Proof Approval.</div>
                    <div>
                        <a href="/account/orders/index">Return to Active Orders</a>
                    </div>
                </div>
            );
        }

        return (
            <div className="proofing-container-02sx">
                <Breadcrumbs
                    className="proofing-container-0sx__breadcrumbs"
                    crumbs={breadcrumbsLinks}
                />
                <If condition={order.processing_id === ORDER_EXPEDITED_PROCESSING}>
                    <IfBeforeCutoff cutoffTime={PROOF_APPROVAL_CUTOFF}>
                        <div className="alert alert-warning d-flex align-items-center justify-content-center">
                            <div
                                style={{background: '#E5B200', color: 'white'}}
                                className="p-3 d-flex align-items-center w-100">
                                <div className="mr-4">
                                    <i className="fa fa-warning" />
                                </div>
                                <div>
                                    <div>
                                        Final Approval must be made by 12pm ET to avoid processing
                                        delays.
                                    </div>
                                    <div>
                                        Time remaining to approve:{' '}
                                        <b>
                                            <DateFromNow withoutSuffix>
                                                {getLocalTime(PROOF_APPROVAL_CUTOFF)}
                                            </DateFromNow>
                                        </b>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </IfBeforeCutoff>
                </If>

                <ReviewProgress className="proofing-container-0sx__progress" />

                <OrderSpecs className="proofing-container-0sx__specs" />

                <div className="proofing-container-0sx__browser-proofing">
                    <ProofsList onInputChange={props.onInputChange} />
                </div>
            </div>
        );
    })
);

const ContainerWithContext = () => {
    const proofingCtx = useProofingContext();
    return <Container {...proofingCtx} />;
};

export default function () {
    return (
        <ProofingContextProvider>
            <ContainerWithContext />
        </ProofingContextProvider>
    );
}
